<template>
  <table class="table mb-0 table-striped">
    <thead class="bg-light">
      <tr>
        <th scope="col" class="border-0">ID</th>
        <th
          scope="col"
          class="border-0"
          :class="{ 'active-sort': multiSort.type }"
          @click="sortBy('type')"
        >
          <div class="header-container">
            Tipo <i :class="getSortIcon('type')"/>
          </div>
        </th>
        <th
          scope="col"
          class="border-0"
          :class="{ 'active-sort': multiSort.chemical_agent }"
          @click="sortBy('chemical_agent')"
        >
          <div class="header-container">
            Agente <i :class="getSortIcon('chemical_agent')"/>
          </div>
        </th>
        <th
          scope="col"
          class="border-0"
          :class="{ 'active-sort': multiSort.employee }"
          @click="sortBy('employee')"
        >
          <div class="header-container">
            Funcionário <i :class="getSortIcon('employee')"/>
          </div>
        </th>
        <th scope="col" class="border-0 text-center">Criado em</th>
        <th scope="col" class="border-0 text-center">Opções</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(row, index) in samples" :key="index">
        <td class="td-1 link">
          <d-link
            :to="{ name: 'admin-sample-edit', params: { sampleId: row.id } }"
          >
            {{ row.sample_no }}
          </d-link>
        </td>
        <td class="td-1">{{ row.type ? row.type.name : '' }}</td>
        <td class="td-1">{{ row.chemical_agent }}</td>
        <td class="td-1 text-center">{{ row.employee }}</td>
        <td class="td-1 text-center">{{ row.f_created_at }}</td>
        <td class="td-2 text-center">
          <sample-buttons :sample="row"></sample-buttons>
        </td>
      </tr>
      <tr v-if="samples.length === 0">
        <td colspan="7" class="no-content">
          Ainda não tem nenhum amostra cadastrado.
        </td>
      </tr>
    </tbody>
    <confirmation-modal
      :cancel="close"
      :confirm="deleteRow"
      title="Confirme exclusão de amostra"
      message="Tem certeza que deseja excluir esse amostra?"
    />
  </table>
</template>

<script>
import Events from '_utils/events';
import CurrencyMask from '_common/mixins/CurrencyMask';
import ConfirmationModal from '_shared/ConfirmationModal.vue';
import SampleDelete from './SampleDelete';
import SampleButtons from './SampleButtons.vue';
import { _DELETE_SAMPLE_ } from './SampleModel';

const NEXT_STATE = {
  null: 'asc',
  asc: 'desc',
  desc: null,
};

const ICONS = {
  null: 'fas fa-sort ml-1 sort-icon-disabled',
  asc: 'fas fa-sort-up ml-1',
  desc: 'fas fa-sort-down ml-1',
};

export default {
  name: 'sample-table',
  mixins: [SampleDelete, CurrencyMask],
  components: {
    SampleButtons,
    ConfirmationModal,
  },
  props: {
    samples: {
      type: Array,
    },
  },
  data() {
    return {
      selectedObject: null,
      multiSort: {
        type: null,
        chemical_agent: null,
        employee: null,
      },
    };
  },
  methods: {
    sortBy(field) {
      const current = this.multiSort[field];
      const next = NEXT_STATE[current];

      this.$set(this.multiSort, field, next);

      this.$emit('sort-changed', { ...this.multiSort });
    },
    getSortIcon(field) {
      const state = this.multiSort[field];

      return ICONS[state];
    },
  },
  mounted() {
    Events.$on(_DELETE_SAMPLE_, sample => {
      this.selectedObject = sample;
    });
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

.td {
  &-1 {
    max-width: 80px;
  }
  &-2 {
    min-width: 120px;
  }
  &-3 {
    min-width: 220px;
  }
}

th {
  white-space: nowrap;

  .header-container {
    display: flex;
    cursor: pointer;
    align-items: center;
    justify-content: flex-start;
  }

  i.fas {
    font-size: 14px;
    width: 15px;
    text-align: center;
  }

  .sort-icon-disabled {
    color: #ced4da;
    opacity: 0.7;
  }

  &.active-sort {
    color: $primary;

    i.fas {
      color: $primary;
      opacity: 1;
    }

    .fa-sort-up { transform: translateY(3px); }
    .fa-sort-down { transform: translateY(-3px); }
  }
}
</style>
